import { render } from "./Game.vue?vue&type=template&id=b33d8598"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=b33d8598&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\命运骑士团\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__